module.exports = __webpack_public_path__ + "img/defalut-avatar.7fb97d11.png";